export default {
  state() {
    return {
      data: null
    };
  },
  getters: {
    get(state) {
      return state
    }
  },
  mutations: {
    data(state, value) {
      state.data = value;
    },
    reset(state) {
      state.code = null;
      state.url = null;
      state.data = null;
    }
  },
};
